import React, { VFC } from 'react';

import { Container } from './styles';
import { ForbiddenProps } from './types';

const Forbidden: VFC<ForbiddenProps> = ({ content }) => (
  <Container>
    <i className="hand" />
    <strong>Notice</strong>
    <p>{content}</p>
  </Container>
);

export default Forbidden;
